import { render, staticRenderFns } from "./Alert_promotion_internet.vue?vue&type=template&id=2e62f7e6&"
import script from "./Alert_promotion_internet.vue?vue&type=script&lang=js&"
export * from "./Alert_promotion_internet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports